// Get client credentials (list)
export const GET_CLIENT_CREDENTIALS = 'GET_CLIENT_CREDENTIALS';
export const GET_CLIENT_CREDENTIALS_SUCCESS = 'GET_CLIENT_CREDENTIALS_SUCCESS';
export const GET_CLIENT_CREDENTIALS_FAILURE = 'GET_CLIENT_CREDENTIALS_FAILURE';

// Create client credential
export const CREATE_CLIENT_CREDENTIAL = 'CREATE_CLIENT_CREDENTIAL';
export const CREATE_CLIENT_CREDENTIAL_SUCCESS = 'CREATE_CLIENT_CREDENTIAL_SUCCESS';
export const CREATE_CLIENT_CREDENTIAL_FAILURE = 'CREATE_CLIENT_CREDENTIAL_FAILURE';

// Delete client credential
export const DELETE_CLIENT_CREDENTIAL = 'DELETE_CLIENT_CREDENTIAL';
export const DELETE_CLIENT_CREDENTIAL_SUCCESS = 'DELETE_CLIENT_CREDENTIAL_SUCCESS';
export const DELETE_CLIENT_CREDENTIAL_FAILURE = 'DELETE_CLIENT_CREDENTIAL_FAILURE';

// Rotate client secret
export const ROTATE_CLIENT_SECRET = 'ROTATE_CLIENT_SECRET';
export const ROTATE_CLIENT_SECRET_SUCCESS = 'ROTATE_CLIENT_SECRET_SUCCESS';
export const ROTATE_CLIENT_SECRET_FAILURE = 'ROTATE_CLIENT_SECRET_FAILURE';

// Clear secret data
export const CLEAR_SECRET_DATA = 'CLEAR_SECRET_DATA';
